import { RequestService } from '../RequestService'
import { useEnvStore } from 'store'

export enum MiningType {
  /** BTC */
  BTC = 2,
  /** LTC */
  LTC = 1,
}

class CloudComputingPowerRequest extends RequestService {
  constructor() {
    super()
  }

  setBaseUrl() {
    const envStore = useEnvStore()

    return (envStore.config?.app || '') + '/v5/cloudmining/'
  }
  /**
   * 挖矿配置
   * @param params
   * @returns
   */
  getMiningConfig() {
    return this.post<CloudComputingPowerResponse.MiningConfig[]>('miningConfig')
  }
  /**
   * 云算力套餐
   * @param params
   * @returns
   */
  getComboList() {
    return this.post<CloudComputingPowerResponse.CloudGoods>('comboListV2')
  }
  /**
   * 云算力套餐详情
   * @returns
   */
  getComboDetail(data: { goodsId: number }) {
    return this.post<CloudComputingPowerResponse.CloudGoodDetail>('comboDetail', data)
  }
  /**
   * 计算器
   * @param params
   * @returns
   */
  getCalculator(data: { mining_type: MiningType; days: string; price: string; num: string }) {
    return this.post<CloudComputingPowerResponse.CalculatorResponse>('calculatorV2', data)
  }
  /**
   * 用户套餐列表
   * @param params
   * @returns
   */
  getUserPositions(data: { status: string }) {
    return this.post<HasPageInfoResponse<CloudComputingPowerResponse.CloudComputingPowerOrder>>('userPositionsV2', data)
  }
  /**
   * 套餐详情
   * @param params
   * @returns
   */
  getUserRights(data: { position_id?: number; mining_type: MiningType }) {
    return this.post<CloudComputingPowerResponse.CloudComputingPowerOrderDetail>('userRights', data)
  }

  /**
   * 套餐详情
   * @param params
   * @returns
   */
  buyGoods(data: { goods_id: number; hash_rate_num: number; renewal: boolean | string | number; tradePwd: string }) {
    return this.post<CloudComputingPowerResponse.CloudComputingPowerOrderDetail>('doPayment', data)
  }

  /**
   * 用户奖励统计
   * @param params
   * @returns
   */
  getUserAwardStat(data: { position_id?: number }) {
    return this.post<CloudComputingPowerResponse.UserAwardStat[]>('userAwardStat', data)
  }

  /**
   * 用户电费账单
   * @param params
   * @returns
   */
  getElectricityBill(data: { page: number; pageSize: number }) {
    return this.post<
      HasPageInfoResponse<CloudComputingPowerResponse.ElectricityBill> & {
        statistic: CloudComputingPowerResponse.ElectricityBillStatistic
      }
    >('electricityBill', data)
  }
  /**
   * 订单每日奖励列表
   * @param params
   * @returns
   */
  getAwardList(data: { page: number; pageSize: number; positionId: number; mining_type: MiningType }) {
    return this.post<HasPageInfoResponse<CloudComputingPowerResponse.CloudComputingPowerOrderDailyDetail>>('awardListV2', data)
  }
  /**
   * 充值电费
   * @param params
   * @returns
   */
  doElectricity(data: { amount: number; itemId: number; tradePwd: string }) {
    return this.post<HasPageInfoResponse<CloudComputingPowerResponse.CloudComputingPowerOrder>>('doElectricity', data)
  }
  /**
   * 电费自动续费开关
   * @param params
   * @returns
   */
  autoElectricity(data: { power_status: number }) {
    return this.post<HasPageInfoResponse<CloudComputingPowerResponse.CloudComputingPowerOrder>>('autoElectricity', data)
  }
  /**
   * 算力K线
   * @returns
   */
  miningKline(data: { positionId?: number; mining_type: MiningType }) {
    return this.post<CloudComputingPowerResponse.CloudComputingPowerMiningKline>('miningKline', data)
  }
  /**
   * 币种价格
   * @returns
   */
  getItemRate() {
    return this.post<CloudComputingPowerResponse.CloudComputingPowerItemRate>('itemRate')
  }
  /**
   * 用户电费余额
   * @returns
   */
  getElectricityBalance() {
    return this.post<string>('electricityBalance')
  }
}
/** 应用服务接口 */
export const CloudComputingPowerServices = new CloudComputingPowerRequest()
